import { render, staticRenderFns } from "./AbsentLetterReasonConfig.vue?vue&type=template&id=73b062ee&scoped=true"
import script from "./AbsentLetterReasonConfig.vue?vue&type=script&lang=js"
export * from "./AbsentLetterReasonConfig.vue?vue&type=script&lang=js"
import style0 from "./AbsentLetterReasonConfig.vue?vue&type=style&index=0&id=73b062ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b062ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b062ee')) {
      api.createRecord('73b062ee', component.options)
    } else {
      api.reload('73b062ee', component.options)
    }
    module.hot.accept("./AbsentLetterReasonConfig.vue?vue&type=template&id=73b062ee&scoped=true", function () {
      api.rerender('73b062ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/absent_letter_v3/components/dialog/AbsentLetterReasonConfig.vue"
export default component.exports